import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import './main.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  customProperties: true,
})
